module.exports = __webpack_public_path__ + "font/f51112347be6b44f9ef46151a971430d.ttf";